import React from 'react'

function About() {
  return (
    <React.Fragment>
        <div className='container'>
            <h1>About</h1>
            <p>My Todo List app 2023</p>
        </div>
    </React.Fragment>
  );
}

export default About;
